module.exports = __webpack_public_path__ + "static/busloclogo-c9a9df2b7c259756ec719c9d87c3df5d.svg";